import { render, staticRenderFns } from "./Highlighted.vue?vue&type=template&id=22b39aa4&"
import script from "./Highlighted.vue?vue&type=script&lang=js&"
export * from "./Highlighted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports